import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState({ message: '', tone: 'success', visible: false });
  const timer = useRef(null);

  const showToast = useCallback((message, tone = 'success') => {
    clearTimeout(timer.current);
    setToast({ message, tone, visible: true });
    timer.current = setTimeout(() => setToast((t) => ({ ...t, visible: false })), 2600);
  }, []);

  useEffect(() => () => clearTimeout(timer.current), []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div
        className={`toast ${toast.tone} ${toast.visible ? 'show' : ''}`}
        role="status"
        aria-live="polite"
      >
        {toast.message}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
  return ctx;
}
